export default class SettingsManager {

    constructor() {
        this.getDefaultSettings = this.getDefaultSettings.bind(this);
    }

    getDefaultSettings() {
        return {
            selectedClientAccountIndex: 0,
            compareMode: 'lastYear'
        }
    }
}